import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;
const API_DESPACHO = import.meta.env.VITE_API_DESPACHO;
const BASENAME = import.meta.env.BASE_URL;
const API_DESPACHO_WEB = import.meta.env.VITE_API_DESPACHO_WEB.replace(/^\//, "");
const API_KEEPER = import.meta.env.VITE_API_KEEPER;

const AttendanceInfoService = {
    getAttendance: async (id) => axios.get(API_URL + `/reports/attendance_info/${id}/data`).then(({ data }) => data).catch((err) => { throw err }),

    getDispatch: (id) => `${BASENAME}${API_DESPACHO_WEB}/dispatch/form/${id}`,

    getOccurrence: (id) => `${BASENAME}bo/${String(id).replace(/\//g, "-")}`,

    getAttach: (id) => API_KEEPER + `/ged/attach/${id}`,

    getImage: (id) => API_URL + `/public/assets/img/file-types/${id}.png`,

    getChat: (id) => API_DESPACHO + `/dispatchHelp/getChat/${id}`,
}

export default AttendanceInfoService;